// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2hotp","select":"Header_select__1CYaX","clinic":"Header_clinic__119wt"};